<div class="flex flex-row">
  <app-toolbar [items]="breadcrumbItems" class="w-100-percent"></app-toolbar>
</div>
<div class="flex flex-row justify-start items-center pl-24 pr-24 pb-8 pt-32 arrow-back">
  <mat-icon (click)="isbPage()" svgIcon="arrow_back"></mat-icon>
  <div class="mat-headline-5 m-0 ml-6">{{'ISB.CREATE_PACKAGE' | transloco }}</div>
</div>

<div class="add-container">
  <div class="p-24" class="form-section pl-20">
    <form [formGroup]="createIsbForm" class="p-8">
      <div class="flex flex-row gap-8">
        <div class="flex flex-col form-fields mb-16">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ISB.BUILD_SOLUTION' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right"
              [matTooltip]="'ISB.CHOOOSE_SOLUTION' | transloco"
              matTooltipPosition="{{constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <select [formControl]="createIsbForm.get('buildSolution')" class="fw-500 form-select" required>
            <option [ngValue]="null" [disabled]="true" hidden>{{'ISB.CHOOOSE_SOLUTION' | transloco}}</option>
            <option *ngFor="let option of lsbSolutionOptions" [ngValue]="option.value">{{ option.value }}</option>
          </select>
          <app-error [control]="createIsbForm.get('buildSolution')"></app-error>
        </div>
        <div class="flex flex-col form-fields mb-16">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ISB.BUILD_VERSION' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right"
              [matTooltip]="'ISB.CHOOSE_VERSION' | transloco"
              matTooltipPosition="{{constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <select [formControl]="createIsbForm.get('buildVersion')" class="fw-500 form-select" required>
            <option [ngValue]="null" [disabled]="true" hidden>{{'ISB.CHOOSE_VERSION' | transloco}}</option>
            <option *ngFor="let option of isbSolutionVersionOption" [ngValue]="option.value">{{ option.value }}</option>
          </select>
          <app-error [control]="createIsbForm.get('buildVersion')"></app-error>
        </div>
      </div>
      <div class="flex flex-row gap-8">
        <div class="flex flex-col form-fields mb-16">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ISB.TYPE' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right"
              [matTooltip]="'ISB.CHOOSE_TYPE' | transloco" matTooltipPosition="{{constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <select [formControl]="createIsbForm.get('type')" class="fw-500 form-select" required>
            <option [ngValue]="null" [disabled]="true" hidden>{{'ISB.CHOOSE_TYPE' | transloco}}</option>
            <option *ngFor="let option of typeOption" [ngValue]="option.value">{{ option.value }}</option>
          </select>
          <app-error [control]="createIsbForm.get('type')"></app-error>
        </div>
        <div class="flex flex-col form-fields mb-16">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ISB.PROVIDER' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right"
              [matTooltip]="'ISB.CHOOSE_PROVIDER' | transloco"
              matTooltipPosition="{{constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <select [formControl]="createIsbForm.get('provider')" class="fw-500 form-select" required>
            <option [ngValue]="null" [disabled]="true" hidden>{{'ISB.CHOOSE_PROVIDER' | transloco}}</option>
            <option *ngFor="let option of providerOption" [ngValue]="option.value">{{ option.value }}</option>
          </select>
          <app-error [control]="createIsbForm.get('provider')"></app-error>

        </div>
        <div class="flex flex-col form-fields mb-16">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ISB.DB_TYPE' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right"
              [matTooltip]="'ISB.CHOOSE_DB_TYPE' | transloco"
              matTooltipPosition="{{constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <select [formControl]="createIsbForm.get('dbtype')" class="fw-500 form-select" required>
            <option [ngValue]="null" [disabled]="true" hidden>{{'ISB.CHOOSE_DB_TYPE' | transloco}}</option>
            <option *ngFor="let option of dbOption" [ngValue]="option.value">{{ option.value }}</option>
          </select>
          <app-error [control]="createIsbForm.get('dbtype')"></app-error>
        </div>
      </div>
    </form>
    <div class="flex flex-row justify-between items-center pl-24 pr-24 pb-8 pt-32">
      <div class="mat-headline-5 m-0"> {{'SOLUTIONS.INCLUDED_CAPABILITIES' | transloco }}</div>
    </div>
    <div class="details-container pl-10">
      <mat-card class="metrics-card mr-16 mb-16">
        <mat-card-content>
          <div class="fw-700 tile-header">
            {{'ISB.TRANSAC' | transloco }}
          </div>
          <div>
            {{'TENANT_DETAILS.COMING_SOON' | transloco }}
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
<div class="footer p-18 mt-120">
  <div class="flex flex-row gap-8 justify-end items-end">
    <button type="button" class="flex justify-center items-center white fw-700 mr-10" (click)="cancelbtn()">
      <mat-icon svgIcon="close" class="icon-md-2 pr-4"></mat-icon>
      {{'BUTTONS.CANCEL' | transloco}}
    </button>
    <button type="button" class="flex justify-center items-center accent fw-700 m-0" (click)="createIsb()"
      [disabled]="!createIsbForm.valid">
      {{'ISB.CONTINUE' | transloco}} <mat-icon svgIcon="arrow_right_alt"></mat-icon>
    </button>
  </div>
</div>